<style>
.preview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 16px;
  margin-top: 20px;
}

.preview-grid>div {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  /* perfect square */
  border-radius: 12px;
  overflow: hidden;
  background: #f8f9fa;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.preview-grid>div:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);
}

.preview-grid img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* important */
  display: block;
}

tr.visible_0 td{
   background-color: #ffcccc !important;
}
</style>
<template>


  <!-- Content -->
  <div class="admin-content">

    <div class="d-flex align-items-center justify-content-between flex-wrap mb-3">
      <!-- Left -->
      <div>
        <h5 class="mb-0 fw-semibold text-color">Store Management</h5>
        <p class="mb-0 text-muted small">
          Manage your Product inventory and categories
        </p>
      </div>
      <!-- Right -->
      <button v-if="user.role == 1" class="btn-primary" data-bs-toggle="modal" data-bs-target="#addNewProduct">
        <i class="fas fa-plus me-2"></i>
        Add New Product
      </button>
    </div>


    <div class="row">
      <div class="col-md-3 col-sm-6 grid-col mob-mt">
        <div class="dashbord-card">
          <div class="d-flex justify-content-between">
            <div>
              <p class="card-p text-primary">Categories</p>
              <p class="card-big-p text-color"> 
                  <PriceFormat :Price="dataz.categorys"/>
              </p>
            </div>
          </div>


        </div>
      </div>

      <div class="col-md-3 col-sm-6 grid-col mob-mt">
        <div class="dashbord-card">
          <div class="d-flex justify-content-between">
            <div>
              <p class="card-p text-danger">Products</p>
              <p class="card-big-p text-color">
                  <PriceFormat :Price="dataz.products"/>
              </p>
            </div>
          </div>


        </div>
      </div>

      <div class="col-md-3 col-sm-6 grid-col mob-mt">
        <div class="dashbord-card">
          <div class="d-flex justify-content-between">
            <div>
              <p class="card-p text-green">Sales Last 7D</p>
              <p class="card-big-p text-color">
                <PriceFormat :Price="dataz.sales_7"/>
              </p>
            </div>
          </div>


        </div>
      </div>

      <div class="col-md-3 col-sm-6 grid-col mob-mt">
        <div class="dashbord-card">
          <div class="d-flex justify-content-between">
            <div>
              <p class="card-p text-orange">Sales Last 30D</p>
              <p class="card-big-p text-color">
               <PriceFormat :Price="dataz.sales_30"/>
              </p>
            </div>
          </div>


        </div>
      </div>
    </div>

      <div v-if="searching" class="mt-1">
            <div class="text-center">
              <div class="spinner-grow text-success" role="status"></div>
              <div class="spinner-grow text-danger" role="status"></div>
              <div class="spinner-grow text-warning" role="status"></div>
            </div>
          </div>

    <div class="simple-tabs mt-3">
      <div class="tabs-menu tab-menu d-flex gap-4">
        <button class="tab-item tab-link" :class="{ active: activeTab === 'products' }" @click="activeTab = 'products'">
          All Products
        </button>

        <button class="tab-item tab-link" :class="{ active: activeTab === 'categories' }"
          @click="activeTab = 'categories'">
          Categories
        </button>
      </div>

      <div class="tab-content mt-3">
        <div v-if="activeTab === 'products'">

          <div class="product-filter-bar d-flex justify-content-between align-items-center flex-wrap gap-3">

            <!-- Left: Search -->
            <div class="filter-search d-flex">
              <input type="text" v-model="this.search_product" class="filter-search-input" placeholder="Search products..." />
              <button class="filter-search-btn">
                <i class="fas fa-search"></i>
              </button>
            </div>

            <!-- Right: Filters -->
            <div class="filter-actions d-flex align-items-center gap-2">
              <!--select class="filter-select">
                <option>All Categories</option>
                <option>Living Room</option>
                <option>Bedroom</option>
                <option>Office</option>
              </select-->

              <select v-model="sortOption" @change="sortProducts" class="filter-select">
                <option value="1">Order By Views</option>
                <option value="2">Order By Sales</option>
               
              </select>

              <!--button class="filter-export-btn">
                <i class="fas fa-download me-1"></i>
                Export
              </button-->
            </div>
          </div>
          <div class="card recent-orders-card mt-3">

            <!-- Card Body -->
            <div class="card-body p-0">
              <div class="table-responsive">
                <table class="table orders-table mb-0">
                  <thead class="">
                    <tr>

                      <th class="td-wd-product">PRODUCT</th>
                      <th class="">P-ID</th>
                      <th class="">PRICE</th>
                      <th>CATEGORY</th>
                      <th>VW's</th>
                      <th>ORDERS-(QNT)</th>
                      <th class="text-end">TOTAL-SALES</th>
                      <th v-if="user.role == 1" class="text-end">ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr :class="'visible_'+product.status" v-for="product in paginatedProducts" :key="product.id">

                      <td class="text-color text-md">
                        <div class="d-flex align-items-center gap-2">
                          <img :src="this.$store.state.img_url + product.thumbnail" class="product-thumb" alt="">
                          <span class="text-md">{{ product.title }}</span>
                        </div>
                      </td>
                      <td class="text-color text-bold text-sm">#{{ product.id }}</td>
                      <td class="text-color text-sm"><PriceFormat :Price="product.price"/></td>
                      <td><span class="status-badge primary-color">{{ product.category_name }}</span></td>
                      <td class="text-color text-sm">{{ product.views }}</td>
                      <td class="text-primary text-bold text-sm">{{ product.total_orders }} Order's ({{product.total_quantity}})</td>
                       <td class="text-color text-end text-bold text-sm">  <PriceFormat :Price="product.total_price"/> /=</td>
                      <td v-if="user.role == 1" class="text-end text-sm">
                        <div class="order-actions">
                    <router-link :to="{path:'/edit-product', query:{product_id:product.id}}" class="order-action-btn edit text-primary" title="Edit">
                            <i class="fas fa-pen"></i>
                    </router-link>
                          <button @click="deleteProduct(product.id)" class="order-action-btn delete text-danger" title="Delete">
                            <i class="fas fa-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>
                                        <div class="pagination-wrapper">

  <button 
    @click="currentPage--"
    :disabled="currentPage === 1">
    Prev
  </button>

  <button
    v-for="page in totalPages"
    :key="page"
    @click="currentPage = page"
    :class="{ active: currentPage === page }">
    {{ page }}
  </button>

  <button
    @click="currentPage++"
    :disabled="currentPage === totalPages">
    Next
  </button>

</div>
            </div>

          </div>
        </div>

        <div v-if="activeTab === 'categories'">
          <div class="d-flex align-items-center justify-content-between flex-wrap mb-2">
            <!-- Left -->
            <div>
              <h6 class="mb-0 fw-semibold text-color">Product Categories</h6>
            </div>
          </div>

          <div class="row">
            <div class="col-md-8 col-sm-12 grid-col">
              <div class="card recent-orders-card mt-3">

                <!-- Card Body -->
                <div class="card-body p-0">
                  <div class="table-responsive">
                    <table class="table orders-table mb-0">
                      <thead class="">
                        <tr>
                          <th class="td-wd-product">CATEGORY</th>
                          <th class="">PROD'S</th>
                          <th>VIEWS</th>
                          <th class="text-end">STATUS</th>
                          <th v-if="user.role == 1" class="text-end">ACTION</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="cats in categories">

                          <td class="text-white text-sm">
                            <div class="d-flex align-items-center gap-2">
                              <img :src="this.$store.state.img_url + cats.thumbnail" class="product-thumb" alt="">
                              <span class="client-name text-color text-sm">{{ cats.name }}</span>
                            </div>
                          </td>

                          <td class="text-muted text-sm">{{ cats.cat_counts }}</td>
                          <td class="text-muted text-sm">{{ cats.views }}</td>
                          <td class="text-primary text-end text-sm">
                            <span v-if="cats.status == 0" class="status-badge red-color"> invisible</span>
                            <span v-if="cats.status == 1" class="status-badge green-color"> visible</span>
                          </td>
                          <td v-if="user.role == 1" class="text-end text-sm">
                            <div class="order-actions">
                              <button @click="selectedCats(cats)" class="order-action-btn text-primary edit" title="Edit">
                                <i class="fas fa-pen"></i>
                              </button>
                              <button @click="deleteCategory(cats.id)" class="order-action-btn text-danger delete" title="Delete">
                                <i class="fas fa-trash"></i>
                              </button>
                            </div>
                          </td>
                        </tr>

                      </tbody>
                    </table>
                  </div>
                </div>

              </div>
            </div>
            <div class="col-md-4 col-sm-8 grid-col">
              <div class="card recent-orders-card mt-3">

                <!-- Card Header -->
                <div class="card-header d-flex justify-content-between align-items-center">
                  <h6 class="mb-0">
                    <span class="text-color">Create Category</span>
                  </h6>
                </div>
                <!-- Card Body -->
                <div class="card-body p-3">
<div class="form-group">
                  <label class="text-muted label mb-1" for="price">Category name</label>
                  <input class="form-control w-100" v-model="category.name" type="text" id="">
                </div>

                <div class="form-group mt-2">
                  <label class="text-muted mb-1" for="price">Visibility</label>
                  <select class="form-control w-100" v-model="category.status">
                    <option value="1">Visible</option>
                    <option value="0">Invisible</option>
                  </select>
                </div>

                 <div class="form-group">
 <label class="text-muted mb-1 mt-2" for="commission">Images</label>
    <input type="file" class="form-control mt-2 mb-2" accept="image/*" @change="handleImage">

    <div v-if="preview" class="preview">
      <img :src="preview">
    </div>

  </div>

                <div class="form-group mb-2">
                <button type="button" @click="submitCategory()" class="btn-primary font-bold mt-3 mt-2">
                  <i class="fas fa-plus me-2"></i>
                  Submit Category
                </button>
              </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--manual enter product-->
    <div class="modal fade" id="addNewProduct" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false">

      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content custom-modal-style">

          <!-- HEADER -->
          <div class="modal-header custom-modal-header d-flex justify-content-between align-items-center">

            <h5 class="modal-title mb-0">Enter Product</h5>
            <button type="button" class="btn-close ms-3 text-white fas fa-xmark" data-bs-dismiss="modal">
            </button>
          </div>

          <!-- BODY -->
          <div class="modal-body custom-modal-body">
            <div>
              <div class="row">
                <div class="col-sm-12 col-md-8">
                   <div class="row">
  <div class="col-md-12 col-sm-12 form-group mt-2">
                  <label class="text-muted mb-2" for="price">Product Name</label>
                  <input class="form-control w-100" type="text" v-model="form.name" id="">
                </div>
                <div class="col-md-6 col-sm-6 form-group mt-2">
                  <label class="text-muted mb-2" for="price">Wealth</label>
                  <input class="form-control w-100" type="text" v-model="form.wealth" id="">
                </div>
                <div class="col-md-6 col-sm-6 form-group mt-2">
                  <label class="text-muted mb-2" for="price">Quantity</label>
                  <input class="form-control w-100" type="text" v-model="form.quantity" id="">
                </div>
               
            
                  <div class="col-md-6 col-sm-6 form-group mt-2">
                  <label class="text-muted mb-1" for="price">Category</label>
                  <select class="form-control w-100" v-model="form.category">
                    <option value="0" selected disabled>Select Category</option>
                    <option :value="cats.id" v-for="cats in categories" :key="cats.id">{{ cats.name }}</option>
                   
                  </select>
                </div>
               

                  <div class="col-md-6 col-sm-6 form-group mt-2">
                  <label class="text-muted mb-1" for="price">Visibility</label>
                  <select class="form-control w-100" v-model="form.status">
                    <option value="1">Visible</option>
                    <option value="0">Invisible</option>
                  </select>
                </div>

                 <div class="col-md-12 col-sm-12 form-group mt-2">
                  <label class="text-muted mb-2" for="video">Youtube Link</label>
                  <input class="form-control w-100" type="text" v-model="form.video" id="">
                </div>

                   </div>
                </div>
                 <div class="col-md-4 col-sm-6 form-group mt-2">
                  <label class="text-muted mb-1" for="price">Price</label>
                  <input class="form-control w-100" type="number" v-model="form.price" id="">
                  <button v-if="this.price_option.length == 0" @click="Discount" class="btn-primary w-100 mt-2 mb-2">Add Discount's</button>
                  <div class="mt-2" v-else>
                    <div class="d-flex gap-2">
                      <input v-model="discount_form.quantity" class="form-control w-30" type="number" placeholder="qnt" name="" id="">
                      <input v-model="discount_form.percent" class="form-control w-30" type="number" placeholder="per%" name="" id="">
                      <button @click="addDiscount" class="btn-primary w-20">add</button>
                    </div>
              
                    <div v-for="item in price_option" :key="item.quantity" class="d-flex justify-content-between mt-2 border-top">
                      <span class="w-20">{{ item.quantity }}</span>
                      <span class="w-20">{{item.percent}} %</span>
                      <span class="w-40">{{ item.price }}</span>
                      <button @click="removeDiscount(item.quantity)" class="btn-danger-icon w-15">x</button>
                    </div>
                  </div>
                </div>


                <div class="col-12 form-group mt-2">
                  <label class="text-muted mb-2" for="price">Product Body</label>
                  <!--textarea class="input-field w-100" v-model="form.body" rows="4" id=""></textarea-->
                  <QuillEditor
      v-model:content="form.body"
      contentType="html"
      theme="snow"
      style="height:300px"
      class="input-field"
    />
                </div>

                <div class="col-md-6 col-sm-12 form-group mt-2">
                  <label class="text-muted mb-1" for="commission">Images (select up to 5 images)</label>

                  <input class="input-field w-100" type="file" multiple accept="image/*" @change="handleImages">
                  <p class="text-xs text-color mb-1">reccommendend jpg, jpeg images of width:600px height:600px</p>
                </div>
              </div>

              <div class="preview-grid">
                <div v-for="(img, index) in previews" :key="index">
                  <img :src="img" />
                </div>
              </div>

              <p v-for="err in errors" class="text-danger mb-0">{{ err }}</p>
              <div class="form-group mt-3 mb-2">
                <button type="button" @click="addNewProduct" class="btn-primary font-bold">
                  <i class="fas fa-plus me-2"></i>
                  Add Product
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>
<script>
import axios from "axios";

import '@vueup/vue-quill/dist/vue-quill.snow.css'

import { QuillEditor } from "@vueup/vue-quill"

import PriceFormat from "@/components/PriceFormat.vue";

export default {
    components: {
    PriceFormat,
    QuillEditor
  },
  data() {
    return {
      searching: false,
      add_btn: true,
      search_product:"",
      errors: [],
      data: [],
      form: {
        name: "",
        price: 0,
        category: 0,
        body: "",
        quantity: 1,
        wealth: 0,
        status: 1,
        video:""
      },
      discount_form:{
        percent:"",
        quantity:""
      },
      price_option:[],
      selectedFiles: [],
      previews: [],
      og_products: [],
      products: [],
      sortOption: 1,
      populars: [],
      categories: [],
      category: {
        id : 0,
        thumbnail:null,
        og_thumbnail:null,
        name:"",
        status : 1,
        og_thumb :""
      },
      preview:null,
      tags: [],
      dataz: {},
       currentPage: 1,
      perPage: 5,
      activeTab: 'products',
      user: this.$attrs.user
    };
  },
  methods: {
     async storeDatas() {
      var response = await axios
        .get(this.$store.state.api_url + "/store-datas")
        .catch((errors) => {
          var message = "Network or Server Errors";
          this.$toast.error(message, { duration: 5000, dismissible: true });
        });

      console.log(response.data)
      if (response.data.success) {

      this.dataz = response.data.dataz;
       
      } else {
        var message = response.data.message;
        this.$toast.error(message, { duration: 5000, dismissible: true });
      }
    },
           selectedCats(category){
       this.category = category
       this.category.og_thumb = category.thumbnail
       this.preview = this.$store.state.img_url + category.thumbnail
    },
        handleImage(e){

const file = e.target.files[0]
if(!file) return

const reader = new FileReader()

reader.onload = (event)=>{

const img = new Image()

img.onload = ()=>{

const canvas = document.createElement("canvas")
canvas.width = 600
canvas.height = 600

const ctx = canvas.getContext("2d")

ctx.drawImage(img,0,0,600,600)

canvas.toBlob((blob)=>{

this.category.thumbnail = new File([blob],"thumb.jpg",{type:"image/jpeg"})

this.preview = URL.createObjectURL(blob)

},"image/jpeg",0.9)

}

img.src = event.target.result

}

reader.readAsDataURL(file)

},
async deleteCategory(id){

  const confirmAssign = window.confirm(
        `Are you sure you want to Delete ?`
      );

      if (!confirmAssign) {
        return
      }

var response = await axios.post(this.$store.state.api_url + "/delete-category",{id})
      .catch((errors) => {
        var message = "Network or Request Errors";
        //alert(message)
        this.$toast.error(message, { duration:5000, dismissible: true });
      });
      if (response.data.success) {
        //alert('Created successfully')

        window.location.reload()

      } else {
          var message = response.data.message
          this.$toast.error(message, { duration:5000, dismissible: true });
        }  
},
async deleteProduct(id){

      const confirmAssign = window.confirm(
        `Are you sure you want to Delete ?`
      );

      if (!confirmAssign) {
        return
      }

var response = await axios.post(this.$store.state.api_url + "/delete-product",{id})
      .catch((errors) => {
        var message = "Network or Request Errors";
        //alert(message)
        this.$toast.error(message, { duration:5000, dismissible: true });
      });
      if (response.data.success) {
        //alert('Created successfully')

        window.location.reload()

      } else {
          var message = response.data.message
          this.$toast.error(message, { duration:5000, dismissible: true });
        }
        
},

async submitCategory(){

if(!this.category.name){
alert("Fill Category name")
return
}
/*
if(this.category.id == 0 && this.category.thumbnail == null){
alert("Choose Image Files")
return
}*/


const formData = new FormData()

formData.append("status",this.category.status)
formData.append("name",this.category.name)
formData.append("id",this.category.id)
formData.append("og_thumb",this.category.og_thumb)

if(this.category.thumbnail){
formData.append("thumbnail",this.category.thumbnail)
}

var response = await axios.post(this.$store.state.api_url + "/create-update-category", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      }).catch((errors) => {
        var message = "Network or Request Errors";
        //alert(message)
        this.$toast.error(message, { duration:5000, dismissible: true });
      });
      if (response.data.success) {
        //alert('Created successfully')

        window.location.reload()

      } else {
       
          var message = response.data.message
          this.$toast.error(message, { duration:5000, dismissible: true });
        
      }


},
    Discount(){
      var price = this.form.price
      if (price == null || price == "") {
        alert("Add Price Above")
      }else{
        
        this.price_option = [{quantity:1, price, percent : 0}]
      }
    },
     addDiscount(){

      var price_ = this.form.price

      var percent = this.discount_form.percent
      var quantity = this.discount_form.quantity
      var dicount = this.price_option

      if (percent == null || percent == "" || quantity == null || quantity == "") {
        
           this.$toast.error('give quantity and percent', { duration:5000, dismissible: true });
      }else{

        var price = ((price_ * quantity) - (((price_ * quantity) * percent)/100))
        //var price = ((price_ * (quantity - 1)) + (price_ - (price_ * percent)/100))

        var newItem = {quantity, price, percent}

         const exists = dicount.some(item => Number(item.quantity) === Number(newItem.quantity));

        if (exists) {
        
           this.$toast.error('Quantity already exists', { duration:5000, dismissible: true });
          return;
        }

        dicount.push(newItem)
        
        this.price_option = dicount

        this.discount_form.percent = ""
        this.discount_form.quantity = ""

      }
    },
    sortProducts() {
    if (this.sortOption == 1) {
      this.products.sort((a, b) => Number(b.views) - Number(a.views))
    }

    if (this.sortOption == 2) {
      this.products.sort((a, b) => Number(b.total_price) - Number(a.total_price))
    }
  },
    removeDiscount(quantity){

      var discounts = this.price_option

      if(quantity > 1){
      discounts = discounts.filter(function( obj ) {
            return obj.quantity != quantity;
        });

        this.price_option = discounts
      }else{
        alert('Cant remove Original price')
      }

    },
    async handleImages(event) {
      const files = Array.from(event.target.files)

      if (files.length > 5) {
        alert("Maximum 5 images allowed")
        return
      }

      this.selectedFiles = []
      this.previews = []

      for (let file of files) {
        const processedFile = await this.makeSquareAndResize(file)
        this.selectedFiles.push(processedFile)
        this.previews.push(URL.createObjectURL(processedFile))
      }
    },
    makeSquareAndResize(file) {

      return new Promise((resolve) => {

        const img = new Image()
        const reader = new FileReader()

        reader.onload = (e) => {
          img.src = e.target.result
        }

        img.onload = () => {

          const size = Math.min(img.width, img.height)

          const canvas = document.createElement("canvas")
          canvas.width = 600
          canvas.height = 600

          const ctx = canvas.getContext("2d")

          // center crop
          const sx = (img.width - size) / 2
          const sy = (img.height - size) / 2

          ctx.drawImage(
            img,
            sx,
            sy,
            size,
            size,
            0,
            0,
            600,
            600
          )

          canvas.toBlob((blob) => {
            const newFile = new File([blob], file.name, {
              type: "image/jpeg"
            })
            resolve(newFile)
          }, "image/jpeg", 0.9)

        }

        reader.readAsDataURL(file)
      })
    },
    async addNewProduct() {
      //alert('wel wel')

      var prices = JSON.stringify(this.price_option)

      const formData = new FormData()

      formData.append("name", this.form.name)
      formData.append("category", this.form.category)
      formData.append("price", this.form.price)
      formData.append("wealth", this.form.wealth)
      formData.append("quantity", this.form.quantity)
      formData.append("body", this.form.body)
      formData.append("status", this.form.status)
      formData.append("video", this.form.video)
      formData.append("price_option", prices)
      

      if (this.selectedFiles.length === 0) {
        formData.append("use_default", "true")
      } else {
        this.selectedFiles.forEach(file => {
          formData.append("gallery", file)
        })
      }

      var response = await axios.post(this.$store.state.api_url + "/create/product", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      }).catch((errors) => {
        var message = "Network or Request Errors";
        //alert(message)
        this.$toast.error(message, { duration:5000, dismissible: true });
      });
      if (response.data.success) {
        //alert('Created successfully')

        window.location.reload()

      } else {
       
        if(response.data.code == 499){
          this.errors = response.data.message
        }else{
          var message = response.data.message
          this.$toast.error(message, { duration:5000, dismissible: true });
        }
        
      }

    },
    async getProducts() {

          this.searching = true
      var response = await axios
        .get(this.$store.state.api_url + "/get-all-products")
        .catch((errors) => {
              this.searching = false
          var message = "Network or Server Errors";
          this.$toast.error(message, { duration: 5000, dismissible: true });
        });

      //console.log(response.data)
      if (response.data.success) {
    this.searching = false
        this.og_products = response.data.products;
        this.products = response.data.products;
      

      } else {
            this.searching = false
        var message = response.data.message;
        this.$toast.error(message, { duration: 5000, dismissible: true });
      }
    },
     async getCategories() {

          this.searching = true
      var response = await axios
        .get(this.$store.state.api_url + "/get-all-categories")
        .catch((errors) => {
              this.searching = false
          var message = "Network or Server Errors";
          this.$toast.error(message, { duration: 5000, dismissible: true });
        });

      //console.log(response.data)
      if (response.data.success) {
    this.searching = false
        this.categories = response.data.categories;
    
      } else {
            this.searching = false
        var message = response.data.message;
        this.$toast.error(message, { duration: 5000, dismissible: true });
      }
    },
       nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++
    }
  },

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--
    }
  }
   

  },
  computed:{
      paginatedProducts() {
    const start = (this.currentPage - 1) * this.perPage
    const end = start + this.perPage

    return this.products.slice(start, end)
  },

  totalPages() {
    return Math.ceil(this.products.length / this.perPage)
  },
  },
  watch: {
  search_product(value) {

    let term = value.toLowerCase().trim()

    if(!term){
      this.products = this.og_products
      return
    }

    this.products = this.og_products.filter(product => {

      return (
        (product.category_name && product.category_name.toLowerCase().includes(term)) ||
        (product.title && product.title.toLowerCase().includes(term))
       
      )

    })

  }
},
  created() {
    this.$store.state.page_name = "Store's"
    this.getCategories()
    this.getProducts()
    this.storeDatas()
  },
};

document.querySelectorAll('.tab-link').forEach(tab => {
  tab.addEventListener('click', () => {
    const target = tab.dataset.tab

    document.querySelectorAll('.tab-link')
      .forEach(t => t.classList.remove('active'))

    document.querySelectorAll('.tab-pane')
      .forEach(p => p.classList.remove('active'))

    tab.classList.add('active')
    document.getElementById(target).classList.add('active')
  })
})
</script>
